import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronLeftSquareFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 15.5q-.69 0-1.302-.015V.515Q7.308.5 8 .5c6.563 0 7.5.938 7.5 7.5s-.937 7.5-7.5 7.5m.341-7.502 2.495 2.495.99-.99-1.505-1.505 1.504-1.504-.99-.99z"
                        fill="currentColor"
                    />
                    <path d="M.5 8C.5 2.472 1.165.935 5.298.588v14.824C1.165 15.065.5 13.528.5 8" fill="currentColor" />
                </g>
            </g>
        </svg>
    )
);
ChevronLeftSquareFilledSize16Glyph.displayName = 'ChevronLeftSquareFilledSize16Glyph';
